import { useState, useEffect } from "react";

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

/**
 * useWindowSize
 *
 * Returns current window dimensions and convenience booleans.
 * Updates on resize with a 100ms debounce.
 */
const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    let timer;
    const handler = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        setSize({ width: window.innerWidth, height: window.innerHeight });
      }, 100);
    };
    window.addEventListener("resize", handler);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", handler);
    };
  }, []);

  return {
    width: size.width,
    height: size.height,
    isMobile: size.width < BREAKPOINTS.mobile,
    isTablet: size.width >= BREAKPOINTS.mobile && size.width < BREAKPOINTS.tablet,
    isDesktop: size.width >= BREAKPOINTS.tablet,
  };
};

export default useWindowSize;
